<template>
  <section>
    <!-- Links de acessibilidade -->
    <a href="#conteudo" id="link-conteudo" accesskey="1" class="skip-link">
      Ir para o conteúdo principal [1]
    </a>
    <a href="#menu" id="link-menu" accesskey="2" class="skip-link">
      Ir para o menu principal [2]
    </a>

    <div id="app">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
export default {
  name: 'app',
  watch: {
    $route() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>
.align-middle {
  vertical-align: middle !important;
}
.skip-link {
  position: absolute;
  left: -999em; /* Move para fora da tela */
  top: 10px;
  background: #000;
  color: #fff;
  padding: 10px;
  z-index: 1000;
}

.skip-link:focus {
  left: 10px; /* Quando focado pelo teclado, aparece na tela */
}
</style>



// WEBPACK FOOTER //
// src/App.vue